import { useParams } from 'react-router-dom';

import Conversation from '@components/Conversation';

const ConversationPage = () => {
  const { conversationId } = useParams<{ conversationId: string }>();
  if (!conversationId) return null;

  return <Conversation conversationId={conversationId} />;
};

export default ConversationPage;
